<template>
    <div class="protocolContent">
      <i class="iconfont iconfanhui back" @click.stop="$router.push({path: '/protocol'})">返回</i>
      <div class="banner">
        <p>心血管疾病风险评估报告</p>
        <p>致您的一封信</p>
      </div>
      <div class="listBox">
        <div class="list">
          <p>《中国心血管病报告》显示， 我国心血管疾病患者约3亿人，心血管疾病已成国人健康的第一杀手，且患病率持续上升。    人体代谢物能够作为健康水平的评价标志物，血浆神经酰胺浓度升高将增加下述疾病的风险：</p>
          <p>（1）心肌梗塞；</p>
          <p>（2） 紧急冠脉血运重建（PCI和CABG）；</p>
          <p>（3）急性冠脉综合征的住院治疗；</p>
          <p>（4） 心血管死亡率脑血管意外（中风）。</p>
          <p>随着科学技术特别是基因技术的不断发展，基因组医学为这些“不治之症”带来了希望。利用最先进的基因检测技术，我们已可以从基因水平对遗传性心血管疾病进行致病基因检测，明确自己或家属携带的致病基因，以便加强临床随诊，诊治更准确。 心血管疾病还受多种危险因素的影响，例如年龄，高血脂，高血压，吸烟，饮酒， 持续关注各类高危影响因素，关注自身心血管疾病风险波动情况，避免出现高危异常情况。                         我们期望通过检测血浆神经酰胺浓度、基因检测以及传统风险评估帮助您早发现心血管疾病的风险，从而进行早干预，早治疗，让您拥有健康的生活。      检测结果可能出现您未预期到的内容，如，可能高于平均水平的疾病风险，这有可能会在心理上及生活上对您产生一定的困扰，或对您的健康产生一定影响，甚至产生社会、法律、经济上的相关影响。我们鼓励您与健康管理师或其他专业人员进行沟通，可以帮助您更好地理解相关结果，以及判断结果对于个人的准确性和适合度。      该风险评估与您的健康状况有关，为获得准确的结果，请您正确填写。您与用户信息关联的信息会得到妥善保护，不会被转移或公开。但将用户信息分离后，相应医学信息可能被用于数据挖掘、算法提升。您可在移动端中，使用更新后的算法。</p>
        </div>
        <div class="list disease">
          <h1 class="title">疾病介绍</h1>
          <p>本产品可用于预测严重心血管疾病的发病风险，该类疾病预后差，但干预措施明确，高风险人群预防措施收益较高。</p>
          <p>心肌梗塞：又称急性心肌梗死，是冠状动脉急性、持续性缺血缺氧所引起的心肌坏死。临床上多有剧烈而持久的胸骨后疼痛，休息及硝酸酯类药物不能完全缓解，伴有血清心肌酶活性增高及进行性心电图变化，可并发心律失常、休克或心力衰竭，常可危及生命。本病在欧美最常见，美国每年约有150万人发生心肌梗死。中国近年来呈明显上升趋势，每年新发至少50万，现患至少200万。</p>
          <p>冠状动脉血运重建：血管重建包括冠状动脉介入治疗（PCI）和冠状动脉旁路移植术(CABG)。在我国，PCI发展很快，2007年全国完成PCI总数达到了144673例。</p>
          <p>急性冠脉综合征：急性冠状动脉综合征（ACS）是以冠状动脉粥样硬化斑块破裂或侵袭，继发完全或不完全闭塞性血栓形成为病理基础的一组临床综合征，包括急性ST段抬高性心肌梗死、急性非ST段抬高性心肌梗死和不稳定型心绞痛，是冠心病的一种严重类型。患者常常表现为发作性胸痛、胸闷等症状，可导致心律失常、心力衰竭、甚至猝死，严重影响患者的。</p>
        </div>
      </div>
      <div class="read">
        <van-checkbox v-model="checked" shape="square" icon-size="13px"></van-checkbox>
        <p>全文阅读完毕</p>
      </div>
      <div class="protocol_btn" @click="goOn">
        <p>同意，继续查看报告</p>
      </div>
    </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  name: 'protocolContent',
  data () {
    return {
      checked: false
    }
  },
  methods: {
    goOn () {
      if (this.checked) {
        this.$router.push('/health')
      } else {
        Toast('请先勾选页面中“全文阅读完毕”')
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/functions";
  .protocolContent {
    background: #C4E3FE;
    .back {
      position: absolute;
      top: pxToRem(20px);
      left: pxToRem(20px);
      font-size: pxToRem(25px);
      color: #000;
    }
    .banner {
      width: 100%;
      height: pxToRem(450px);
      background: url('../../assets/images/ceramide/protolConBg.png') no-repeat center;
      background-size: 100% 100%;
      text-align: center;

      p:first-of-type {
        padding-top: pxToRem(150px);
      }
      p {
        font-size: pxToRem(50px);
        font-weight: bold;
        color:rgba(0,0,0,1);
        line-height: pxToRem(63px);
        background: linear-gradient(-38deg,rgba(161,196,253,1) 0%, rgba(194,233,251,1) 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin-bottom: pxToRem(10px);
      }
    }
    .listBox {
      position: relative;
      z-index: 11;
      clear: both;
      width: 100%;
      padding: pxToRem(20px) pxToRem(30px);
      padding-bottom: 0;
      margin-top: pxToRem(-80px);

      .list {
        position: relative;
        background-color: #fff;
        border-radius: pxToRem(20px);
        padding: pxToRem(50px) pxToRem(30px);
        z-index: 11;
        font-size: pxToRem(17px);
        font-weight: 400;
        color: rgba(89,87,87,1);
        margin-bottom: pxToRem(40px);

        p {
          text-indent: 1em;
        }
      }

      .disease {

        .title {
          position: absolute;
          top: 0;
          left: 0;
          font-size: pxToRem(42px);
          font-weight:bold;
          letter-spacing: pxToRem(10px);
          color: #fff;
          padding: pxToRem(20px) pxToRem(34px) pxToRem(20px) pxToRem(40px);
          background: linear-gradient(-29deg, rgba(114,190,255,1), rgba(99,163,255,1));
          box-shadow: 0px 4px 6px 0px rgba(26, 69, 57, 0.35);
          border-radius: pxToRem(20px) 0 0 0;
        }

        p:first-of-type {
          margin-top: pxToRem(100px);
        }
      }
    }

    .read {
      font-size: pxToRem(20px);
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: pxToRem(30px);

      p {
        margin-left: pxToRem(10px);
        line-height: 1em;
      }
    }

    .protocol_btn {
      text-align: center;

      p {
        display: inline-block;
        background: url('../../assets/images/ceramide/healthbtn.png') no-repeat center;
        background-size: 100% 100%;
        font-size: pxToRem(28px);
        color: #fff;
        text-align: center;
        padding: pxToRem(12px) pxToRem(50px);
        margin: pxToRem(60px) auto pxToRem(184px);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/ceramide/protocolContent.vue